import { GetterTree } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import AddressesState from '../../types/Address/AddressesState'

const getters: GetterTree<AddressesState, RootState> = {
  getAddressList: state => state.addresses,
  getAddressById: state => addressId => {
    return state.addresses.find(a => a.id === addressId)
  },
  getDefaultAddress: state => state.addresses.find(address => address.default_shipping) || false,
  getGuestAddresses: state => state.guest_addresses,
  getHasAddress: (state, getters, rootState) => {
    if (rootState.user && rootState.user.current) {
      return !!state.addresses.length;
    }
    return !!state.guest_addresses.length;
  }
}

export default getters
